/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiVehicleBodyType {
    Sedan = 'SEDAN',
    SedanBig = 'SEDAN_BIG'
}

export function ApiVehicleBodyTypeFromJSON(json: any): ApiVehicleBodyType {
    return ApiVehicleBodyTypeFromJSONTyped(json, false);
}

export function ApiVehicleBodyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiVehicleBodyType {
    return json as ApiVehicleBodyType;
}

export function ApiVehicleBodyTypeToJSON(value?: ApiVehicleBodyType | null): any {
    return value as any;
}

